exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".formStyle_addressNumber__3X7KB {\n    min-width: 100px;\n    margin-left: 10px;\n}\n\n@media (max-width: 600px) {\n    .formStyle_addressNumber__3X7KB {\n        min-width: 0;\n        margin-left: 0;\n        width: 100%;\n    }\n}", ""]);

// Exports
exports.locals = {
	"addressNumber": "formStyle_addressNumber__3X7KB"
};